var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgITickConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_6268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.20453C3.86429 1.20453 0.5 4.56881 0.5 8.70453C0.5 12.8402 3.86429 16.2045 8 16.2045C12.1357 16.2045 15.5 12.8402 15.5 8.70453C15.5 4.56881 12.1357 1.20453 8 1.20453ZM11.0589 7.47774L7.84464 10.692C7.7375 10.7938 7.60357 10.8474 7.46429 10.8474C7.325 10.8474 7.19107 10.7938 7.08393 10.692L5.47679 9.08489C5.26786 8.87596 5.26786 8.5331 5.47679 8.32417C5.68571 8.11524 6.02857 8.11524 6.2375 8.32417L7.46429 9.55631L10.2982 6.71703C10.5071 6.5081 10.85 6.5081 11.0589 6.71703C11.2679 6.92596 11.2679 7.26881 11.0589 7.47774Z",
    fill: "#B2D88F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_6268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.704529)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITickConnected);
export default __webpack_public_path__ + "static/media/i-tick-connected.1166fe0e0b4b0dfa33ea5f6a60414515.svg";
export { ForwardRef as ReactComponent };